import { createPlatformState } from '~/helpers/store'

export default () => {
  const state = createPlatformState()

  return {
    ...state,
    meta: {
      ...state.meta,
      searches: {}
    },
    filters: {
      categories: [],
      venueId: []
    }
  }
}
